import React from 'react';

const Notfound = () => {
    return (
        <div className='mx-auto lg:max-w-lg mt-8 mb-8'>
            <h2 className='text-3xl text-accent text-center mb-5'>Page Not Found</h2>
            <img src="https://i.ibb.co/jVF8Cfw/404.webp" alt="Not Found" />
        </div>
    );
};

export default Notfound;